import { Bar, mixins } from "vue-chartjs";

export default {
    extends: Bar,
    mixins: [mixins.reactiveProp],
    props: ["options"],
    mounted() {
        // reactiveProp mixin handles data updates automatically
        this.renderChart(this.chartData, this.options);
    }
};
